
import { useNavigate } from 'react-router-dom';
import Footer from '../footer/Footer';
import styles from './landingpage.module.scss';

export default function LandingPage() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    //const auth = useSelector((state: RootState) => state.authSlice.auth);
    const navigate = useNavigate();

    return (
        <>
            <div className="max-w-7xl mx-auto px-4">
                <div className={styles.contentb}>
                    <div className={styles.wrapperb}>

                        <div style={{ marginTop: "5em" }}>
                            <h3 style={{ textAlign: "center" }}>Beratung und Umsetzung von IT Projekten</h3>
                        </div>

                        <div style={{ marginTop: "3em" }}>
                            Besonders Selbständige und kleine Unternehmen stehen häufig vor dem Problem, dass Standardlösungen entweder zu teuer oder nicht flexibel genug sind.
                            Individuell entwickelte Software passt sich dagegen genau an Ihre Prozesse an – effizient, skalierbar und ohne unnötige Funktionen.
                        </div>

                        <div style={{ marginTop: "3em" }}>
                            Sie suchen eine digitale Lösung für Ihr Unternehmen? Ich berate Sie gerne persönlich und zeige Ihnen, welche Möglichkeiten zu Ihren individuellen Anforderungen passen.

                            Vom Auftragseingang über Backofficelösungen bis zur Rechnungsstellung.
                            {/*} oder finden bereits jetzt das richtige <button className="btn btn-light" onClick={() => navigate("/produkte")}>Produkt</button> für Ihr Unternehmen. */}
                        </div>

                        <div className={styles.fpVorteil}>
                            <div className={styles.card_lp_1} style={{ textAlign: "center" }}>Einfach</div>
                            <div className={styles.card_lp_1} style={{ textAlign: "center" }}>Schnell</div>
                            <div className={styles.card_lp_1} style={{ textAlign: "center" }}>Direkt</div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div >
        </>
    );
}
